import React from 'react'
import ReactDOM from 'react-dom'

import Provider from '@react/react-spectrum/Provider'

import './style/index.css'
import App from './component/App'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
    <Provider theme="light" scale="medium" typekitId="wvs4frr">
        <App />
    </Provider>, document.getElementById('root'))

serviceWorker.unregister()
